module.exports = __webpack_public_path__ + "static/media/IMG_3475_sm.5ee03262.jpg";